import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const CaretRightSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" d="m6 11.954 3.952-3.931L6.096 4" />
  </IconV2>
);

export default CaretRightSmallIcon;
